import { CancelToken } from 'axios'
import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'
import { AnalyticOutputLayoutSizeEnum } from '../../../../../enums/analytic-output-layout-size.enum'

export const postStudyObjectOutputService = (
  reportId: string,
  inputId: string,
  layoutSize: AnalyticOutputLayoutSizeEnum,
  cancelToken?: CancelToken,
) =>
  apiInstance.post(
    ApiPathConfig.STUDY_OBJECT_OUTPUT(reportId, inputId),
    { layout_size: layoutSize },
    {
      cancelToken,
    },
  )
